import React from "react";
import lax from "lax.js";
import { Link } from "react-router-dom";
import TicketModal from "./TicketModal1";

class About1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
    };
    lax.setup();
  }

  componentDidUpdate(prevProps, prevState) {
    // If modal state changed
    if (this.state.isModalOpen !== prevState.isModalOpen) {
      if (this.state.isModalOpen) {
        document.body.style.overflow = "hidden"; // Lock scroll
      } else {
        document.body.style.overflow = "auto"; // Unlock scroll
      }
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = "auto";
  }

  toggleModal = (e) => {
    if (e) e.preventDefault();
    this.setState({ isModalOpen: !this.state.isModalOpen });
  };

  render() {
    return (
      <section className="about-area ptb-120 bg-image" id="rang-barse">
        <div className="container">
          <div className="row h-100 align-items-center">
            <div className="col-lg-6 order-2 order-lg-1">
              <div className="about-content">
                <h2><b>Rang barse 2.0:</b> Pune’s Ultimate Holi Bash 2026 - Wakad</h2>
                <p>Rain Dance | Punjabi Dhol | Organic Colours | Family Section | Kids Play Arena | Food | Music | Dance | Festive Vibe</p>
                <p>Get ready for Pune's most electrifying Rang Barse 2.0 - Holi Bash 2026! Celebrate Holi with organic colors, power-packed DJ performances, and a vibrant atmosphere. Dance to the beats of well known DJs, experience live dhol, and enjoy premium food and beverages in vibrant resto-lounge Saundarya Garden, Wakad. A vibrant Holi experience with rain dance, organic colors and pure fesstive vibes!</p>
                
                <Link to="#" className="btn btn-secondary" onClick={this.toggleModal}>
                  Buy Ticket
                </Link>
              </div>
            </div>
            <div className="col-lg-6 order-1 order-lg-2">
              <div className="about-image">
                <img src={require("../../assets/images/holi/holi5.jpg")} className="about-img1" alt="about" style={{  width: "100%", objectFit: "contain"}} />
              </div>
            </div>
          </div>
        </div>

        <TicketModal isOpen={this.state.isModalOpen} onClose={this.toggleModal} />
      </section>
    );
  }
}

export default About1;